// extracted by mini-css-extract-plugin
export default {"linksPanel":"LinksPanel_linksPanel__mpEch","header":"LinksPanel_header__Xja4e","links":"LinksPanel_links__b7Y1m"};